import axios from "axios";
import { useEffect, useState } from "react";
import Swal from 'sweetalert2';
import { Spinner } from "react-bootstrap";

const POTypeChange = ({ type, po }) => {
  const [showSave, setShowSave] = useState(false);
  const [newType, setNewType] = useState(type || "");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setNewType((type || "").trim().toUpperCase());
  }, [type]);

  const handleInputChange = (e) => {
    setNewType(e.target.value.trim().toUpperCase());
  };

  const handleEdit = () => {
    setShowSave(true);
  }

  const handleSubmit = async() => {

    const result = await Swal.fire({
        title: 'Are you sure?',
        // icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, submit it!',
        cancelButtonText: 'Cancel',
        customClass: {
          popup: "custom-swal-popup", 
          confirmButton: "custom-confirm-button", 
          cancelButton: "custom-cancel-button", 
        },
      });
      if(result.isConfirmed){
        setLoading(true);
        try{
            const response = await axios.post(`/admin/changePOTyp`,
                {
                    PO: po,    
                    typ: newType    
                }
            )
            console.log('response check', response)
            setNewType(newType);
            Swal.fire('Success!', 'PO type updated.', 'success');
        }
        catch (error) {
            setNewType(type);
            console.error('error:', error);          
            const errorMessage = error?.response?.data?.message || "Something went wrong";
            Swal.fire('Error', errorMessage, 'error');
          }
        finally{
            setShowSave(false);
            setLoading(false);
        }
      }

  };

  return (
    <td>
      <div className="d-flex align-items-center gap-2">
        <input
          type="text"
          value={newType}
          disabled= {!showSave}
          onChange={(e) => handleInputChange(e)}
          className="form-control form-control-sm"
          style={{ width: "40px" }}
          maxLength={2}
        />
        <button
          onClick={showSave === false ? handleEdit : handleSubmit}
          className={
            showSave === false
              ? "btn btn-sm btn-primary"
              : "btn btn-sm btn-success"
          }
          style={{ width: "43px" }}
          disabled = {loading}
        >
          {showSave === false ? ("Edit" ): (loading ? <Spinner size="sm"/> : "Save")}
        </button>
      </div>
    </td>
  );
};
export default POTypeChange;
